class StaticVideoFunctions {

    static getBackgroundImage(videoId, videoSource) {

        let imageUrl = this.getVideoImageUrl(videoId, videoSource);

        return (imageUrl) ? 'url(' + imageUrl + ')' : 'none';

    }

    static getVideoImageUrl(videoId, videoSource = 'YouTube') {

        if (videoSource === 'YouTube') {
            return 'https://i.ytimg.com/vi/' + videoId + '/0.jpg';
        } else if(videoSource === 'Vimeo') {
            return null;
            //return 'https://i.vimeocdn.com/video/' + videoId + '.jpg';
            //return 'http://b.vimeocdn.com/ts/399/121/' + videoId + '_1280.jpg';
        } else {
            return 'image-not-found';
        }

    }

    static getVideoUrl(videoId, videoSource = 'YouTube') {

        if (videoSource === 'YouTube') {
            return 'https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1';
        } else if(videoSource === 'Vimeo') {
            return 'https://player.vimeo.com/video/' + videoId;
        } else {
            return 'url-not-found';
        }

    }

}

export default StaticVideoFunctions;